import React from 'react';
import Navigation from 'src/components/Navigation';
import { adminTopLinks, adminBottomLinks } from '../Constants';
import SidebarContextTree, {
  SidebarContextRow,
} from '../Components/SidebarContextTree';
import usePropertyContextRows from '../Hooks/usePropertyContextRows';
import useServiceRequestContextRows from '../Hooks/useServiceRequestContextRows';
import useContactContextRows from '../Hooks/useContactContextRows';
import useItemContextRows from '../Hooks/useItemContextRows';
import useAnnouncementContextRows from '../Hooks/useAnnouncementContextRows';
import { SidebarPermissionsData } from '../ModernSidebar';

interface AdminSidebarNavProps {
  collapseSideBar: boolean;
  permissions: SidebarPermissionsData;
}

const CONTEXT_PRIORITY: string[] = [
  'serviceRequests',
  'properties',
  'contacts',
  'catalog',
  'announcements',
];

const AdminSidebarNav = ({ collapseSideBar }: AdminSidebarNavProps) => {
  const rowsByContext: Record<string, SidebarContextRow[] | null> = {
    serviceRequests: useServiceRequestContextRows(),
    properties: usePropertyContextRows(),
    contacts: useContactContextRows(),
    catalog: useItemContextRows(),
    announcements: useAnnouncementContextRows(),
  };

  const matchedContextId: string | undefined = CONTEXT_PRIORITY.find(
    (contextId: string): boolean => {
      return rowsByContext[contextId] !== null;
    }
  );

  const activeContextId: string | null = matchedContextId ?? null;

  const activeContextRows: SidebarContextRow[] | null = activeContextId
    ? rowsByContext[activeContextId]
    : null;

  if (!activeContextId || !activeContextRows || collapseSideBar) {
    return (
      <>
        <Navigation links={adminTopLinks} collapseSideBar={collapseSideBar} />
        <div className="sidebar-spacer" />
        <Navigation
          links={adminBottomLinks}
          collapseSideBar={collapseSideBar}
        />
      </>
    );
  }

  // Insert the context tree directly beneath its own top-nav link: split the links there.
  const activeLinkIndex: number = adminTopLinks.findIndex(
    (link: any) => link.id === activeContextId
  );

  const linksThroughActive: any[] = adminTopLinks.slice(0, activeLinkIndex + 1);

  const linksAfterActive: any[] = adminTopLinks.slice(activeLinkIndex + 1);

  return (
    <>
      <Navigation
        links={linksThroughActive}
        collapseSideBar={collapseSideBar}
      />
      <SidebarContextTree rows={activeContextRows} />
      <Navigation links={linksAfterActive} collapseSideBar={collapseSideBar} />
      <div className="sidebar-spacer" />
      <Navigation links={adminBottomLinks} collapseSideBar={collapseSideBar} />
    </>
  );
};

export default AdminSidebarNav;
